<app-combo-button [config]="{ alignMenuRight: true }"
                  (optionSelected)="optionSelected($event)"
                  [options]="options$ | async"
                  [label]="label">
</app-combo-button>